"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var StepTheme = function StepTheme(colors) {
  return {
    defaultProps: {
      expanded: true
    },
    styleOverrides: {
      root: {
        '&.Mui-completed .MuiStepContent-root': {
          borderLeftColor: colors.bleuDigital100
        }
      }
    }
  };
};

var _default = StepTheme;
exports["default"] = _default;